import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import React from 'react';

// Utils
import { getPatternDateTime } from '@/main/services/utilsDate';

import { useStyles } from '../inputText/styles';

const EMPTY_STYLES_PARAMS = {};

interface KogKeyboardDateTimePickerProps {
  error: boolean;
  id: string;
  value: Date;
  name: string;
  label: string;
  onChange: (date: any) => void;
  disabled?: boolean;
}

export default React.memo(function KogKeyboardDateTimePicker({
  error,
  id,
  value,
  name,
  label,
  onChange,
  disabled = false
}: KogKeyboardDateTimePickerProps) {
  const classes = useStyles(EMPTY_STYLES_PARAMS);

  return (
    <DateTimePicker
      slotProps={{
        textField: {
          className: classes.inputText,
          size: 'small',
          variant: 'filled',
          fullWidth: true,
          helperText: null,
          name: name,
          error: error,
          id: id
        }
      }}
      label={label}
      disabled={disabled}
      format={getPatternDateTime()}
      value={value}
      onChange={(date: any) => {
        onChange(date);
      }}
    />
  );
});